import { createContext } from './utils';
import { Snapshot } from '../types';

export interface WithSnapshot {
    snapshot: Snapshot;
    refreshSnapshot: () => Promise<void>;
}

const {
    Consumer,
    Provider,
    withContext: withSnapshot,
    Context,
} = createContext<WithSnapshot>({
    snapshot: {
        skills: [],
        operations: [],
        timezones: [],
        categories: [],
        voices: [],
        regionsWithSufficientLanguages: [],
        maxSkillsPerUser: 1000,
    },
    refreshSnapshot: () => Promise.resolve(),
});

export { Consumer, Provider, withSnapshot, Context };
